import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.organizations.root,
    element: <Loadable component={() => import('./pages/OrganizationsPage')} />,
  },
  {
    path: paths.organizations.details.root,
    element: (
      <Loadable component={() => import('./pages/OrganizationDetailsPage')} />
    ),
    children: [
      {
        path: paths.organizations.details.tab,
        element: (
          <Loadable
            component={() => import('./pages/OrganizationDetailsPage')}
          />
        ),
      },
    ],
  },
];
